import { useCallback } from 'react';
import * as backend from 'src/backend/donations';

/**
 * Custom hook for handling food image analysis
 * @returns {Object} Hook methods and state
 */
const useFoodAnalysis = () => {
  /**
   * Analyze food images using AI via backend API
   * @param {File[]} files - Array of image files to analyze
   * @param {Object} context - Additional context for analysis
   * @param {string} context.donorName - Name of the donor organization
   * @param {string} context.organizationType - Type of organization
   * @param {Array} context.inventoryItems - Selected inventory item details
   * @returns {Promise<Object>} Analysis results
   */
  const analyzeImages = useCallback(async (files, context = {}) => {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('images', file);
      });

      if (context.donorName) {
        formData.append('donorName', context.donorName);
      }
      if (context.organizationType) {
        formData.append('organizationType', context.organizationType);
      }
      if (context.inventoryItems?.length) {
        formData.append(
          'inventoryItems',
          JSON.stringify(context.inventoryItems)
        );
      }

      const result = await backend.analyzeFoodImages(formData);

      return result;
    } catch (error) {
      return {
        success: false,
        error: error?.message || 'An unknown error occurred',
      };
    }
  }, []);

  return {
    analyzeFoodImages: analyzeImages,
  };
};

export default useFoodAnalysis;
